import React, { Component } from "react";
import { FiChevronLeft } from "react-icons/fi";
import { Link } from "react-router-dom";
import Image from "../../../base/features/micro/Image";

class UserCustomProductBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedImage: null,
    };
  }

  render() {
    return (
      <Link to={`/custom-products/${this.props.product.uid}`} className="px-0">
        <div className="row mx-0 p-0 border rounded14 mb-3">
          <div className="col-12 p-3 border-bottom">
            <div className="row mx-0 px-0">
              <div className="col-auto px-1 align-self-center">
                <Image
                  imageUri={
                    this.props.product.shop.cover &&
                    this.props.product.shop.cover.thumbnail
                  }
                  imageHeight={"40"}
                  imageWidth={"40"}
                  imgClassName={"rounded-circle img-cover"}
                  extraClassName={"rounded-circle p-2 bg-color-main"}
                />
              </div>
              <div className="col px-1 align-self-center">
                <p className="fw-bolder mb-0 fs-6">
                  {this.props.product.shop && this.props.product.shop.title}
                  {this.props.product.shop &&
                    this.props.product.shop.is_verify && (
                      <img
                        width="15"
                        className="me-1"
                        alt="verify"
                        src={
                          require("../../../base/assets/icons/verify.svg")
                            .default
                        }
                      />
                    )}
                </p>
                <p className="fw-bolder mb-0 fs-7 text-muted">
                  {this.props.product.created}
                </p>
              </div>
              <div className="col-auto px-1 align-self-center">
                <p
                  className={
                    "mb-0 small fw-bold " +
                    (this.props.product.status === 1
                      ? "color-main"
                      : this.props.product.status === 0
                      ? "text-warning"
                      : "text-danger")
                  }
                >
                  {this.props.product.status === 1
                    ? "ثبت شده"
                    : this.props.product.status === 0
                    ? "در حال آماده سازی"
                    : "موافقت نشده"}
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 p-3">
            <div className="row mx-0 px-0">
              <div className="col align-self-center px-1">
                {this.props.product.medias.map((media, m) => (
                  <div className="d-inline-block ms-2">
                    <Image
                      imageUri={media.thumbnail}
                      imageHeight={"40"}
                      imageWidth={"40"}
                      imgClassName={"rounded7 img-cover"}
                      extraClassName={"rounded-circle p-2 bg-color-main"}
                    />
                  </div>
                ))}
              </div>
              <div className="col-auto px-1 align-self-center">
                <p className="color-main fw-bold mb-1" dir="ltr">
                  <FiChevronLeft size="24" className="" />
                  جزئیات
                </p>
              </div>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}

export default UserCustomProductBlock;
